import lunamycard from './pay/lunamycard'

const channelNameNew = {
    10014: 'Lunamycard',
};
const channelDetailNew = [
    {
        name: 'Lunamycard',
        key: 'lunamycard',
        methods: lunamycard
    }
];

export {channelDetailNew, channelNameNew};



// WEBPACK FOOTER //
// ./src/config/channelsNew.js